import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from '@serasa/core/modules/users/services/user.service';
import { Observable } from 'rxjs';

@Injectable()
export class InvalidateCacheInterceptor implements HttpInterceptor {

  constructor(
    private readonly _userService: UserService
  ) { }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const mustInvalidateCahe = req.headers.has("Invalidate-Cache");

    if (mustInvalidateCahe) {
      this._userService.invalidateLogonsCache();
      req = req.clone({ headers: req.headers.delete("Invalidate-Cache") });
    }

    return next.handle(req);
  }

}
